<template lang="pug">
  div.form-group(:class="{'has-error': has_error}")
    label(:for="name" v-if="showLabel")
      span(v-text="labelText")
      small.required(v-if="required") Required
    slot
    span.form-text.error-message(v-if="has_error && error_message", v-text="error_message")
    small.form-text.text-muted(v-if="!has_error && helpText", v-text="helpText")
</template>

<script>
import { has, first, get, isEmpty, startCase } from "lodash-es";

export default {
  name: "AppField",
  props: {
    required: Boolean,
    name: String,
    label: String,
    helpText: String
  },
  data: () => ({
    has_error: false,
    error_message: ""
  }),
  computed: {
    showLabel() {
      return this.label !== false;
    },
    labelText() {
      return isEmpty(this.label)
        ? startCase(String(this.name).replace(/_id$/, ""))
        : this.label;
    }
  },
  mounted() {
    this.$parent.$on("errors", errors => {
      this.has_error = has(errors, this.name);
      this.error_message = first(get(errors, this.name));
    });
  }
};
</script>

<style lang="scss">
.form-group {
  &.has-error {
    color: red;
    input {
      color: red;
      border-color: red;
    }
  }
}
</style>
